/** @jsxImportSource @emotion/react */
import React from 'react';
import type { DivProps } from '../../../../../../typings';
import Text from 'ud-ui/components/text';
import * as S from './styles';

interface IProps extends DivProps {
  icon?: React.ReactNode;
}

function Label(props: IProps) {
  const { icon, children, ...rest } = props;

  return (
    <S.MainBlock {...rest}>
      {icon ?? null}
      {children && (
        <Text type="subhead" color="inherit" style={{ fontWeight: 'inherit' }}>
          {children}
        </Text>
      )}
    </S.MainBlock>
  );
}

export default Label;
